module.exports = __webpack_public_path__ + "img/me-night-bottom-bg_ar.f2142b81.png";